import { type } from '../actions/type';


const INITIAL_STATE = {
    dData: null,
    uData: null,
    dSearchData: null,
    domainDistribution: null,
    search: null,
}

const coldSmtpReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        

        case type.COLD_SMTP_SEARCH_TERM:
            return { ...state, search: action.payload.searchTerm }

        case type.COLD_SMTP_USER_RESULT:
            return { ...state, uData: action.payload.userData, dSearchData: action.payload.dSearchData };

        case type.COLD_SMTP_DOMAINSEARCH_RESULT:
             return { ...state, dSearchData: action.payload.dSearchData, uData: action.payload.userData };

        case type.COLD_SMTP_DOMAIN_RESULT:
            return {
                ...state,
                dData: action.payload.domainData,
                domainDistribution: action.payload.domainDistribution ? action.payload.domainDistribution : state.domainDistribution
            };

        case type.COLD_SMTP_RESET_DOMAIN_RESULT:
            return { ...state, dData: null }
            
        default:
            return state;
    }
}
export default coldSmtpReducer;